import React, { useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CommonButton from '../common/components/CommonButton';
import { CommonButtonVariants } from '../constants/CommonButtonVariants';
import PublishOfferModal from './PublishOfferModal';
import '../assets/css/componentStyles/AddVehicleHeader.css';

function AddVehicleHeader({
  onSaveDraft,
  onPublish,
  isSaving,
  isPublishing,
  className,
  title = 'Add Vehicle Auction',
  saveDraftLabel = 'SAVE DRAFT',
  publishLabel = 'PUBLISH OFFER',
  disabled = false,
  isScheduledAuction = false,
}) {
  const [isPublishModalOpen, setIsPublishModalOpen] = useState(false);

  const isButtonsDisabled = useMemo(
    () => disabled || isSaving || isPublishing,
    [disabled, isSaving, isPublishing],
  );

  const publishButtonLabel = useMemo(
    () => (
      <span>
        <span className="checkmark-icon" aria-hidden="true">
          ✓
        </span>
        {publishLabel}
      </span>
    ),
    [publishLabel],
  );

  const headerClassName = useMemo(
    () => classNames('add-vehicle-header', className),
    [className],
  );

  const handlePublishClick = useCallback(() => {
    setIsPublishModalOpen(true);
  }, []);

  const togglePublishModal = useCallback(() => {
    setIsPublishModalOpen((prev) => !prev);
  }, []);

  const handleConfirmPublish = useCallback(() => {
    onPublish();
  }, [onPublish]);
  return (
    <>
      <div className={headerClassName}>
        <div className="header-content">
          <div className="header-title">
            <h2>{title}</h2>
          </div>
          <div className="header-actions">
            <div className="d-flex save-draft-btn-wrapper">
              <CommonButton
                label={saveDraftLabel}
                variant={CommonButtonVariants.SECONDARY}
                className="save-draft-btn w-100"
                handleClick={onSaveDraft}
                disabled={isButtonsDisabled}
                aria-label="Save vehicle draft"
              />
            </div>
            <div className="d-flex publish-offer-btn-wrapper">
              <CommonButton
                label={publishButtonLabel}
                variant={CommonButtonVariants.PRIMARY}
                className="publish-offer-btn"
                handleClick={handlePublishClick}
                disabled={isButtonsDisabled}
                aria-label="Publish vehicle offer"
              />
            </div>
          </div>
        </div>
        <div className="header-separator" />
      </div>

      <PublishOfferModal
        isOpen={isPublishModalOpen}
        toggle={togglePublishModal}
        onConfirm={handleConfirmPublish}
        isPublishing={isPublishing}
        publishLabel={publishLabel}
        isScheduledAuction={isScheduledAuction}
      />
    </>
  );
}

AddVehicleHeader.propTypes = {
  onSaveDraft: PropTypes.func.isRequired,
  onPublish: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
  isPublishing: PropTypes.bool,
  className: PropTypes.string,
  title: PropTypes.string,
  saveDraftLabel: PropTypes.string,
  publishLabel: PropTypes.string,
  disabled: PropTypes.bool,
};

AddVehicleHeader.defaultProps = {
  isSaving: false,
  isPublishing: false,
  className: '',
  title: 'Add Vehicle Auction',
  saveDraftLabel: 'SAVE DRAFT',
  publishLabel: 'PUBLISH OFFER',
  disabled: false,
};

export default AddVehicleHeader;
